import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import typedToPlain from './middleware/typedToPlain';

const finalCreateStore = applyMiddleware(
    thunk,
    typedToPlain
)(createStore);

export default finalCreateStore;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/redux/createStore.prod.ts
 **/